import React from 'react';
import { Edit2, Eye } from 'react-feather';

import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const getEditText = (contentType, isDraft, isCertification) => {
  const TYPE_TO_DISPLAY = {
    lesson: t('common.lesson'),
    path: t('common.path'),
    resource: t('common.resource'),
    practice_container: t('common.scenario'),
  };

  if (isCertification) {
    return `${t('actions.edit')} ${t('common.certification')}`;
  }

  if (contentType === 'lesson' || contentType === 'resource') {
    return isDraft ? t('drafts.edit_draft') : t('drafts.create_draft');
  }
  if (contentType === 'draft_lesson') {
    return t('drafts.edit_draft');
  }
  return `${t('actions.edit')} ${TYPE_TO_DISPLAY[contentType]}`;
};

const AdvancedSearchResultCardBack = React.forwardRef(
  (
    { urls, editable, isDraft, contentType, certificationId, setIsFocused },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className="AdvancedSearchResultCard-back d-f fd-c bg-white p-24"
        onClick={e => e.stopPropagation()}
        onKeyDown={() => {}}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      >
        <div className="AdvancedSearchResultCard-back-top d-f fd-c jc-c ai-c">
          <a
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            href={urls.overview}
            className="text-center"
          >
            <Text variant={TEXT_VARIANTS.BODY}>
              {t('contents.advanced_search.view_overview')}
            </Text>
          </a>
        </div>
        <div className="AdvancedSearchResultCard-back-divider" />
        <div className="AdvancedSearchResultCard-back-bottom d-f fd-c jc-c">
          {editable && (
            <a
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              className="d-f"
              href={urls.edit}
            >
              <Edit2
                className="c-midnight-50 AdvancedSearchResultCard-icon-content"
                size={18}
              />
              <Text variant={TEXT_VARIANTS.BODY}>
                {getEditText(contentType, isDraft, certificationId)}
              </Text>
            </a>
          )}
          <a
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className="d-f mt-24"
            href={urls.preview}
          >
            <Eye
              className="c-midnight-50 AdvancedSearchResultCard-icon-content"
              size={18}
            />
            <Text variant={TEXT_VARIANTS.BODY}>
              {t('contents.advanced_search.preview_content')}
            </Text>
          </a>
        </div>
      </div>
    );
  },
);

export default AdvancedSearchResultCardBack;
